exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2281015c] .nav-link--btn{color:#3490dc}", ""]);

// exports
